import './Coordinates.scss';

import * as Yup from 'yup';

import { Col, Form, Row } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi';
import { REG_EXP } from '../../utils/constants';
import iconLocation from '../../assets/images/ubisoft-playtest-icon-location-black.webp';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  handleChange: any;
  updateSchema: (value: any) => void;
}

const Coordinates = ({ values, errors, handleChange, updateSchema }: Props) => {
  const intl = useIntl();

  useEffect(() => {
    const coordinatesSchema = {
      city: Yup.string()
        .trim()
        .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })),
      postalCode: Yup.string()
        .trim()
        .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
        .matches(
          new RegExp(REG_EXP.postalCode),
          intl.formatMessage({ ...siteMessages.FIELD_INVALID })
        ),
      phoneNumber: Yup.string()
        .trim()
        .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
        .matches(
          new RegExp(REG_EXP.phone),
          intl.formatMessage({ ...siteMessages.FIELD_INVALID })
        )
    };
    updateSchema(coordinatesSchema);
  }, []);

  return (
    <div className="coordinates">
      <div className="header">
        <img src={iconLocation} alt="" />
        <h3>{intl.formatMessage({ ...messages.headerCoordinates })}</h3>
      </div>
      <div className="content">
        <Row>
          <Col md className="city">
            <Form.Group controlId="city">
              <Form.Label className="input">
                {intl.formatMessage({ ...messages.city })}
              </Form.Label>
              <Form.Control
                name="city"
                onChange={handleChange}
                defaultValue={values.city}
                required
                isInvalid={errors.city}
              />
              <Form.Control.Feedback type="invalid">
                <FiAlertTriangle className="mb-1 me-1" />
                {errors.city}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md className="postalCode">
            <Form.Group controlId="postalCode">
              <Form.Label className="input">
                {intl.formatMessage({ ...messages.postalCode })}
              </Form.Label>
              <Form.Control
                name="postalCode"
                onChange={handleChange}
                defaultValue={values.postalCode}
                required
                isInvalid={errors.postalCode}
              />
              <Form.Control.Feedback type="invalid">
                <FiAlertTriangle className="mb-1 me-1" />
                {errors.postalCode}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group controlId="phoneNumber" className="mt-4 phoneNumber">
          <Form.Label className="input">
            {intl.formatMessage({ ...messages.phoneNumber })}
          </Form.Label>
          <Form.Control
            name="phoneNumber"
            onChange={handleChange}
            defaultValue={values.phoneNumber}
            required
            isInvalid={errors.phoneNumber}
          />
          <Form.Control.Feedback type="invalid">
            <FiAlertTriangle className="mb-1 me-1" />
            {errors.phoneNumber}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
    </div>
  );
};

export default Coordinates;
